/**
 * Change Password page (under construction).
 *
 * @module pages/changePassword
 */

import React              from 'react';
import Layout             from '../components/Layout';
import UnderConstruction  from '../components/UnderConstruction';
import { useI18n }        from '../dataProviders/I18nProvider';

/**
 * Renders the Change Password placeholder page.
 *
 * @returns {React.ReactElement}
 */
export default function ChangePassword() {
  const { t } = useI18n();

  return (
    <Layout title={t('page.changePassword')}>
      <UnderConstruction />
    </Layout>
  );
}
